var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('br'), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading,
      "is-full-screen": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('ul', {
    staticClass: "nav nav-tabs mb-3"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.activeTab === 'shipment'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.switchTab('shipment')
      }
    }
  }, [_vm._v("Mark Shipment Shortage")])]), _vm._v(" "), (_vm.isPaperworkShortageEnabled) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.activeTab === 'parentAwb'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.switchTab('parentAwb')
      }
    }
  }, [_vm._v("Mark Parent AWB Shortage")])]) : _vm._e()]), _vm._v(" "), (_vm.activeTab === 'shipment') ? _c('div', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("Mark shipment Shortage")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('h6', [_vm._v("ShipmentId"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-input-group', [(((_vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon)).type) === 'checkbox') ? _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingid),
      expression: "shippingid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    ref: "shippingid",
    class: {
      'form-control': true
    },
    attrs: {
      "name": "shippingid",
      "placeholder": "Enter ShippingId",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.shippingid) ? _vm._i(_vm.shippingid, null) > -1 : (_vm.shippingid)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.shippingid,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.shippingid = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.shippingid = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.shippingid = $$c
        }
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false)) : (((_vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon)).type) === 'radio') ? _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingid),
      expression: "shippingid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    ref: "shippingid",
    class: {
      'form-control': true
    },
    attrs: {
      "name": "shippingid",
      "placeholder": "Enter ShippingId",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.shippingid, null)
    },
    on: {
      "change": function($event) {
        _vm.shippingid = null
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false)) : _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingid),
      expression: "shippingid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    ref: "shippingid",
    class: {
      'form-control': true
    },
    attrs: {
      "name": "shippingid",
      "placeholder": "Enter ShippingId",
      "type": (_vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon)).type
    },
    domProps: {
      "value": (_vm.shippingid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingid = $event.target.value
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shippingid')),
      expression: "errors.has('shippingid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("ShippingId field is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Show")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])])])])], 1)]), _vm._v(" "), (_vm.showTable == true) ? _c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Shipment Details")]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "200px",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("shippingID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shipmentDetails.shippingid))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shipmentDetails.shipmentstatus))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shipmentDetails.status))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "badge badge-success",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.ConfirmShipmentShortageMark
    }
  }, [_vm._v("Mark Shortage")])])])])])])], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'parentAwb' && _vm.isPaperworkShortageEnabled) ? _c('div', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Mark Parent AWB Shortage")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('h6', [_vm._v("Parent AWB"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parentawb),
      expression: "parentawb"
    }],
    ref: "parentawb",
    class: {
      'form-control': true
    },
    attrs: {
      "name": "parentawb",
      "placeholder": "Enter Parent AWB"
    },
    domProps: {
      "value": (_vm.parentawb)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.openParentAwbShortageConfirm.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.parentawb = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.parentAwbError),
      expression: "parentAwbError"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Parent AWB field is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 parent-awb-action-btns"
  }, [_c('button', {
    staticClass: "common-success mark-shortage-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openParentAwbShortageConfirm
    }
  }, [_vm._v("Mark Shortage")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger mark-shortage-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetParentAwbForm
    }
  }, [_vm._v("Reset")])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.ConfirmShipmentShortage == true) ? _c('b-modal', {
    attrs: {
      "size": "md",
      "title": "Are You Sure"
    },
    model: {
      value: (_vm.ConfirmShipmentShortage),
      callback: function($$v) {
        _vm.ConfirmShipmentShortage = $$v
      },
      expression: "ConfirmShipmentShortage"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.CloseConfirmation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Are you sure to mark shipment as shortage")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isDisabledOK == true
    },
    on: {
      "click": function($event) {
        return _vm.MarkShipmentShortage(_vm.shipmentDetails)
      }
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.CloseConfirmation
    }
  }, [_vm._v("Cancel")])])])])]) : _vm._e(), _vm._v(" "), (_vm.confirmParentAwbShortage) ? _c('div', {
    staticClass: "parent-awb-shortage-overlay"
  }, [_c('div', {
    staticClass: "parent-awb-shortage-dialog"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeParentAwbConfirmation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-success mark-shortage-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.isDisabledParentAwbOK == true
    },
    on: {
      "click": _vm.markParentAwbShortage
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger mark-shortage-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeParentAwbConfirmation
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e()], 1)], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Are you sure to mark parent AWB as shortage?")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4750754a","hasScoped":true}!./src/views/components/MarkShipmentShortage/MarkShipmentShortage.html
// module id = 1213
// module chunks = 2